<div [ngClass]="{'blur-background': isDialogOpen}">
  <!-- Il contenuto principale del tuo sito -->
  <app-preloader></app-preloader>
  <!-- <app-demo-sidebar></app-demo-sidebar> -->
  <router-outlet></router-outlet> 
</div>
